// Projects types
export const PROJECT_FORM = "PROJECT_FORM";
export const GET_PROJECTS = "GET_PROJECTS";
export const ADD_PROJECT = "ADD_PROJECT";
export const VALIDATE_FORM = "VALIDATE_FORM";
export const ACTUAL_PROJECT = "ACTUAL_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const ERROR_PROJECT = "ERROR_PROJECT";

// Tasks types
export const PROJECT_TASKS = "PROJECT_TASKS";
export const ADD_TASK = "ADD_TASK";
export const VALIDATE_TASK = "VALIDATE_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const ACTUAL_TASK = "ACTUAL_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const CLEAN_TASK = "CLEAN_TASK";

// Alert types
export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";

// Auth tyes
export const SUCCESS_REGISTER = "SUCCESS_REGISTER";
export const ERROR_REGISTER = "ERROR_REGISTER";
export const GET_USER = "GET_USER";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOG_OUT = "LOG_OUT";